'use client'
import { memo, useEffect, useMemo, useState } from 'react'
import ErrorBoundary from '@error-boundary'
import dynamic from 'next/dynamic'

import { CardLazyWrapper } from '@components/cards/RaCardLazyWrapper/RaCardLazyWrapper'
import { RaContainer } from '@components/core/index.core'
import { AcfInspirationBlock, AcfInspirationBlocksProps } from '@typings'
import { Loop } from '@utilities/helpers/core.helpers'

import styles from './acf-inspiration-blocks.module.scss'

const InspirationCardsCarousel = dynamic(() =>
  import(
    '@/components/carousels/InspirationCardsCarousel/InspirationCardsCarousel'
  ).then(mod => mod.InspirationCardsCarousel)
)

export const AcfInspirationBlocks = memo(
  ({ blocks }: AcfInspirationBlocksProps) => {
    const [isMobile, setIsMobile] = useState(null)
    const cards = useMemo(() => {
      if (!blocks) return null

      return Loop(blocks, (item: AcfInspirationBlock, i: number) => (
        <CardLazyWrapper
          renderCard="inspiration"
          key={`desktop-inspiration-${i}`}
          {...{ props: item }}
        />
      ))
    }, [blocks])

    const handleResize = () => {
      const viewport = window.innerWidth
      setIsMobile(viewport < 768)
    }

    useEffect(() => {
      handleResize()
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
      <RaContainer>
        {isMobile === false && (
          <div className={styles['acf-inspiration-blocks']}>{cards}</div>
        )}
        <ErrorBoundary>
          {isMobile && <InspirationCardsCarousel cards={blocks} />}
        </ErrorBoundary>
      </RaContainer>
    )
  }
)

AcfInspirationBlocks.displayName = 'AcfInspirationBlocks'
